import React from 'react';
import './Projects.css';

const Projects = () => {
  return (
    <div className="projects project__section" id='projects'>
        <h2 className="section__title">Projects</h2>

        
    </div>
  )
}

export default Projects
